import React, { useEffect, useState } from "react";
import axios from "axios";

export default function FittingAdding() {
  const [fittingProfiles, setFittingProfiles] = useState([]);
  const [selectedProfile, setSelectedProfile] = useState("");
  const [sizeName, setSizeName] = useState("");
  const [measurements, setMeasurements] = useState([{ name: "", value: "" }]);
  const [loading, setLoading] = useState(false);

  
  useEffect(() => {
    const fetchFittings = async () => {
      try {
        const res = await axios.get(
          "https://tailor.beezetsoftwaresolution.com/api/costume/get_costume.php"
        );
        setFittingProfiles(res.data); 
      } catch (err) {
        console.error("Error fetching fitting profiles:", err);
      }
    };
    fetchFittings();
  }, []);

  
  const addMeasurement = () => {
    setMeasurements([...measurements, { name: "", value: "" }]);
  };

 
  const handleMeasurementChange = (index, field, value) => {
    const updated = [...measurements];
    updated[index][field] = value;
    setMeasurements(updated);
  };

  
  const handleSubmit = async () => {
    if (!selectedProfile || !sizeName || measurements.length === 0) {
      alert("Please fill all required fields.");
      return;
    }

    const payload = {
      costume_id: Number(selectedProfile),
      size_name: sizeName,
      measurements: measurements.map((m) => ({
        name: m.name,
        value: m.value,
      })),
    };

    setLoading(true);
    try {
      const res = await axios.post(
        "https://tailor.beezetsoftwaresolution.com/api/costume/add_costume_fittings.php",
        payload
      );
      alert(res.data.message || "Fitting profile saved successfully!");
      setSizeName("");
      setMeasurements([{ name: "", value: "" }]);
      setSelectedProfile("");
    } catch (err) {
      console.error("Error submitting data:", err);
      if (err.response?.data?.error) {
        alert(err.response.data.error);
      } else {
        alert("Failed to save fitting profile.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-semibold text-blue-700 mb-4">
        Add Costume Fitting
      </h2>

      
      <div className="mb-4">
        <label className="block text-sm font-medium text-blue-700 mb-1">
          Select Profile Fitting
        </label>
        <select
          value={selectedProfile}
          onChange={(e) => setSelectedProfile(e.target.value)}
          className="border p-2 rounded w-full focus:ring-2 focus:ring-blue-700"
        >
          <option value="">-- Select Profile Fitting --</option>
          {fittingProfiles.map((profile) => (
            <option key={profile.name} value={profile.name}>
  {profile.profile_name || profile.costume_name} (Name: {profile.name})
</option>
          ))}
        </select>
      </div>

      
      <div className="mb-4">
        <label className="block text-sm font-medium text-blue-700 mb-1">
          Size Name
        </label>
        <input
          type="text"
          value={sizeName}
          onChange={(e) => setSizeName(e.target.value)}
          placeholder="e.g. Medium"
          className="border p-2 rounded w-full focus:ring-2 focus:ring-blue-700"
        />
      </div>

     
      <div>
        <label className="block text-sm font-medium text-blue-700 mb-2">
          Measurements
        </label>

        {measurements.map((m, i) => (
          <div key={i} className="flex gap-3 mb-3">
            <input
              type="text"
              placeholder="Measurement Name (e.g., Chest)"
              value={m.name}
              onChange={(e) =>
                handleMeasurementChange(i, "name", e.target.value)
              }
              className="border p-2 rounded w-1/2 focus:ring-2 focus:ring-blue-700"
            />
            <input
              type="text"
              placeholder="Measurement Value (e.g., 42 inches)"
              value={m.value}
              onChange={(e) =>
                handleMeasurementChange(i, "value", e.target.value)
              }
              className="border p-2 rounded w-1/2 focus:ring-2 focus:ring-blue-700"
            />
          </div>
        ))}

        <button
          onClick={addMeasurement}
          className="bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-800 mt-2"
        >
          + Add Measurement
        </button>
      </div>

      
      <div className="mt-6 text-right">
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="bg-blue-700 hover:bg-blue-800 text-white px-5 py-2 rounded"
        >
          {loading ? "Saving..." : "Save Fitting Profile"}
        </button>
      </div>
    </div>
  );
}
